import { useEffect } from "react";

//Context
import { useAuth } from "../context/auth.jsx";

const Home = () => {
  const { signOut } = useAuth();

  //### USE EFFECT ###
  useEffect(() => {
    signOut();
  }, []);

  return (
    <div className="text-center">
      <br />
      <br />
      <br />
      <br />

      <h1>SIIG WEB ONLINE</h1>

      <br />

      {/* <div>Pagina de marketing do sistema</div> */}
    </div>
  );
};

export default Home;
